module.exports = __webpack_public_path__ + "img/bg_avatar_male_14.e682de65.png";